module.exports = "/lucky-balls/img/drum/drum_loop_031.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drum/drum_loop_031.png
// module id = 1046
// module chunks = 0